<template>
    <div>
        <div v-if="!isLoading && isOps">
            <main-ten v-if="main_tenis"></main-ten>
            <kunci-penginputan
                v-if="!main_tenis && !dibuka"
            ></kunci-penginputan>
        </div>

        <div v-if="!isOps || (isOps && dibuka)">
            <div v-if="!main_tenis && !isLoading">
                <v-app id="inspire" class="main-page myFont">
                    <v-navigation-drawer
                        v-model="drawer"
                        app
                        class="elevation-10 d-block"
                        id="main-sidebar"
                    >
                        <v-list-item class="profile-bg" align="center">
                            <v-list-item-content class="pt-10 pb-15">
                                <v-list-item-subtitle class="font-weight-bold"
                                    >Selamat datang !</v-list-item-subtitle
                                >
                                <v-list-item-title
                                    class="font-weight-bold deep-purple--text font-bordered"
                                >
                                    {{ user.nama }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-card flat tile color="transparent" class="mb-3">
                            <v-sheet
                                rounded
                                align="center"
                                class="rounded-t-xl mt-n5"
                            >
                                <v-avatar
                                    size="60"
                                    color="deep-purple"
                                    class="mt-n7 my-outlined white--text"
                                >
                                    {{
                                        user.role == "superadmin"
                                            ? "super"
                                            : user.role
                                    }}
                                </v-avatar>
                            </v-sheet>
                            <v-sheet
                                rounded
                                align="center"
                                class="rounded-t-xl mt-n5"
                                v-if="jensek"
                            >
                                <v-avatar
                                    size="30"
                                    color="orange darken-4"
                                    class="mt-2 my-outlined white--text"
                                >
                                    <span class="text-caption">{{
                                        jensek
                                    }}</span>
                                </v-avatar>
                            </v-sheet>
                        </v-card>
                        <my-nav></my-nav>
                    </v-navigation-drawer>

                    <v-app-bar app class="indigo-blue" dark>
                        <v-app-bar-nav-icon
                            @click.stop="drawer = !drawer"
                        ></v-app-bar-nav-icon>
                        <v-toolbar-title>Aplikasi Sekolah</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-menu
                            bottom
                            :left="!isMobile"
                            transition="slide-y-transition"
                            offset-y
                            :close-on-content-click="false"
                            v-model="coker"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    text
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-4"
                                    :disabled="$route.path == '/app/my-pesan'"
                                >
                                    <v-badge
                                        v-if="pesans.length > 0"
                                        overlap
                                        :content="pesans.length"
                                        color="red"
                                    >
                                        <v-icon>mdi-bell</v-icon>
                                    </v-badge>
                                    <v-icon v-else>mdi-bell</v-icon>
                                </v-btn>
                            </template>
                            <v-sheet
                                class="rounded"
                                :width="!isMobile ? '500px' : ''"
                            >
                                <v-toolbar dense flat class="pr-4">
                                    <v-toolbar-title
                                        class="
                      px-1
                      text-subtitle-1
                      font-weight-bold
                      grey--text
                      text--darken-1
                    "
                                        >Pesan Baru (<span class="orange--text"
                                            >{{
                                                only_ten_unread_pesans.length
                                            }}
                                            dari {{ pesans.length }}</span
                                        >)</v-toolbar-title
                                    >
                                    <v-spacer></v-spacer>
                                    <v-tooltip bottom>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                small
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                                :disabled="pesans.length == 0"
                                                @click="markAll"
                                            >
                                                <v-icon color="orange"
                                                    >mdi-email-open-multiple-outline</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Tandai semua dibaca !</span>
                                    </v-tooltip>
                                </v-toolbar>
                                <v-divider></v-divider>
                                <v-responsive
                                    class="overflow-y-scroll"
                                    max-height="320px"
                                >
                                    <v-list class="py-0">
                                        <template
                                            v-for="(item,
                                            index) in only_ten_unread_pesans"
                                        >
                                            <v-list-item :key="item.id" link>
                                                <v-list-item-content
                                                    @click="
                                                        toRoute(
                                                            item.data.route,
                                                            item.id,
                                                            item.data.to
                                                        )
                                                    "
                                                >
                                                    <v-list-item-subtitle
                                                        class="indigo--text"
                                                        ><v-icon left>
                                                            mdi-account-tie </v-icon
                                                        >{{
                                                            item.data.nama
                                                        }}</v-list-item-subtitle
                                                    >
                                                    <div
                                                        class="
                              subtitle-2
                              d-flex
                              grey--text
                              text--darken-1
                              font-weight-bold
                            "
                                                    >
                                                        <v-icon left
                                                            >mdi-message-alert-outline</v-icon
                                                        >
                                                        <span>
                                                            {{
                                                                item.data.pesan
                                                            }}
                                                            <i
                                                                class="font-weight-bold"
                                                                v-if="
                                                                    item.data
                                                                        .color
                                                                "
                                                                :class="
                                                                    item.data
                                                                        .color +
                                                                        '--text'
                                                                "
                                                                >{{
                                                                    item.data
                                                                        .status_text
                                                                }}</i
                                                            ></span
                                                        >
                                                    </div>
                                                    <v-list-item-subtitle
                                                        class="orange--text"
                                                        v-if="item.data.due"
                                                        ><v-icon left>
                                                            mdi-calendar </v-icon
                                                        >{{
                                                            item.data.due
                                                        }}</v-list-item-subtitle
                                                    >
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-tooltip bottom>
                                                        <template
                                                            v-slot:activator="{
                                                                on,
                                                                attrs
                                                            }"
                                                        >
                                                            <v-btn
                                                                icon
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                @click="
                                                                    markRead(
                                                                        item.id
                                                                    )
                                                                "
                                                                ref="read"
                                                            >
                                                                <v-icon
                                                                    color="orange"
                                                                    >mdi-email-open-outline</v-icon
                                                                >
                                                            </v-btn>
                                                        </template>
                                                        <span
                                                            >Tandai dibaca
                                                            !</span
                                                        >
                                                    </v-tooltip>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-divider
                                                v-if="
                                                    index != pesans.length - 1
                                                "
                                                :key="index"
                                            ></v-divider>
                                        </template>
                                    </v-list>
                                </v-responsive>
                                <v-divider></v-divider>
                                <v-toolbar dense flat>
                                    <v-btn
                                        class="px-1"
                                        @click="toPesan"
                                        color="primary"
                                        text
                                        block
                                        >Lihat SEMUA PESAN</v-btn
                                    >
                                    <!-- <v-btn class="px-1" @click="toPesan" color="primary" text block
                >Lihat semua pesan({{
                  pesansAll.length > 0 ? pesansAll.length : 0
                }})</v-btn
              > -->
                                </v-toolbar>
                            </v-sheet>
                        </v-menu>
                        <v-menu transition="slide-y-transition" bottom offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    text
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-1"
                                >
                                    <v-avatar size="40px" color="indigo">
                                        <v-icon color="white">
                                            mdi-account-circle
                                        </v-icon>
                                    </v-avatar>
                                </v-btn>
                            </template>
                            <v-list class="" style="width: 300px">
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <!-- <img
                  src="https://randomuser.me/api/portraits/men/81.jpg"
                  alt="user"
                /> -->
                                        <v-avatar size="40px" color="indigo">
                                            <v-icon color="white">
                                                mdi-account-circle
                                            </v-icon>
                                        </v-avatar>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ user.nama }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            {{ user.role }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-for="(item, i) in menus"
                                    :key="i"
                                    :to="item.path"
                                >
                                    <v-list-item-title>{{
                                        item.title
                                    }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="logout">
                                    <v-list-item-title class="red--text"
                                        >Logout</v-list-item-title
                                    >
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-app-bar>

                    <v-main class="my-main">
                        <TestBanner />
                        <v-container fluid>
                            <v-row justify="center">
                                <v-col>
                                    <loading-assets
                                        v-if="$root.loading"
                                    ></loading-assets>
                                    <transition name="fade" mode="out-in">
                                        <router-view
                                            class="main-view"
                                            :class="
                                                fluid ? 'container--fluid' : ''
                                            "
                                            name="MainView"
                                            @sidenav="doFull"
                                            :nav="drawer"
                                        ></router-view>
                                    </transition>
                                    <confirm-one ref="confirmOne"></confirm-one>
                                    <dialog-tolak
                                        ref="dialogTolak"
                                    ></dialog-tolak>
                                    <sql-fail ref="sqlFail"></sql-fail>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-main>
                    <my-notif></my-notif>
                    <my-overlay></my-overlay>
                    <log-aplikasi></log-aplikasi>
                </v-app>
            </div>
            <main-ten v-if="main_tenis && !isLoading"></main-ten>
        </div>

        <div class="loading-page" v-if="isLoading">
            <loading-page></loading-page>
        </div>

        <v-app v-if="buildDialog && !isLoading">
            <v-dialog max-width="500px" persistent v-model="buildDialog">
                <v-card>
                    <v-card-text class="pt-3 text-center black--text text-h5">
                        <div class="mb-1">Pembaharuan Aplikasi tersedia.</div>
                        <div>
                            *Silahkan
                            <span class="font-weight-bold red--text"
                                >CLEAR BROWSER CACHE</span
                            >
                            ANDA!

                            <div class="mt-4">
                                <video
                                    controls
                                    playsinline
                                    autoplay
                                    muted
                                    poster="/assets/img/clear-cache.JPG"
                                    style="width: 100%"
                                >
                                    <source
                                        src="/assets/videos/clear-cache.mp4"
                                        type="video/mp4"
                                    />
                                </video>
                            </div>
                        </div>
                        <!-- <v-btn @click="updateAplikasi" color="primary">
              Update Aplikasi
            </v-btn> -->
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-app>
    </div>
</template>

<script>
import { mapState } from "vuex";
import MyNav from "./core/MyNav";
import MyNotif from "./core/MyNotif";
import MyOverlay from "./core/MyOverlay";
import ConfirmOne from "./core/confirm/ConfirmOne";
import DialogTolak from "./core/dialog/DialogTolak";
import SqlFail from "./core/SqlFail";
import LoadingPage from "./LoadingPage"; //lets import LoadingPage component
import LogAplikasi from "./LogAplikasi.vue";
import MainTen from "./MainTen.vue";
import KunciPenginputan from "./core/KunciPenginputan.vue";
import TestBanner from "./TestBanner.vue";

export default {
    components: {
        ConfirmOne,
        MyNav,
        MyNotif,
        MyOverlay,
        DialogTolak,
        SqlFail,
        LoadingPage,
        LogAplikasi,
        MainTen,
        KunciPenginputan,
        TestBanner
    },

    data() {
        return {
            build: "20230213",
            buildDialog: false,
            fluid: true,
            isLoading: true,
            drawer: true,
            currentUser: {},
            token: localStorage.getItem("token"),
            menus: [{ title: "Akun saya", path: "/app/akun-saya" }],
            param: false,
            coker: false,
            ready: 0,
            logoutPressed: false
        };
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.dispatch("auth/getUser").then(r => {
                if (r.oke) {
                    let user_id = vm.$store.state.auth.user.id;
                    let user_role = vm.$store.state.auth.user.role;
                    // vm.fillAllNotif(user_id);
                    if (user_role == "ops") {
                        vm.fillNotifOps(user_id);
                        vm.fillSekolahnya(user_role, user_id);
                        vm.fillConfigPenginputan();
                    } else if (user_role == "admin") {
                        vm.fillNotifAdmin(user_id);
                        vm.fillDinas(user_role);
                        vm.fillConfig();
                    } else {
                        vm.ready++;
                    }
                }
            });
        });
    },

    watch: {
        "$route.path": {
            immediate: true,
            handler() {
                this.coker = false;
            }
        },
        pesans: {
            immediate: false,
            handler() {
                if (!this.pesans.length) {
                    this.coker = false;
                }
            }
        },
        ready(val) {
            let role = this.$store.state.auth.user.role;
            if (role == "ops") {
                if (val == 3) {
                    this.isLoading = false;
                    this.$store.commit("SET_OVERLAY", false);
                }
            } else if (role == "admin") {
                if (val == 2) {
                    this.isLoading = false;
                    this.$store.commit("SET_OVERLAY", false);
                }
            } else {
                this.isLoading = false;
                this.$store.commit("SET_OVERLAY", false);
            }
        }
    },

    mounted() {
        const interval = setInterval(() => {
            if (this.$refs.confirmOne) {
                this.$root.$confirmOne = this.$refs.confirmOne.open;
                this.$root.$sf = this.$refs.sqlFail.open;
                this.$root.$tolak = this.$refs.dialogTolak.open;
                clearInterval(interval);
            }
        }, 50);
    },

    created() {
        this.getAppVersion();
    },

    computed: {
        jensek_id() {
            if (this.isOps && this.user) {
                return this.$store.state.auth.user.sekolah.jensek_id;
            }
        },
        dibuka() {
            let open = false;
            let hideLog = localStorage.getItem("dev");
            if (hideLog) {
                return true;
            }
            let kunciItems = this.$store.state.config.penginputanItems;
            let cok = kunciItems.find(x => {
                return x.jensek_id == this.jensek_id;
            });

            if (cok && cok.open) open = true;
            return open;
        },
        main_tenis() {
            let hideLog = localStorage.getItem("dev");
            if (hideLog) {
                return false;
            }
            if (this.$store.state.app_info) {
                return this.$store.state.app_info.main_tenis;
            }
        },
        isMobile() {
            return this.$vuetify.breakpoint.xs;
        },
        ...mapState("auth", ["user"]),
        pesans() {
            return this.$store.state.pesans;
        },

        only_ten_unread_pesans() {
            return this.pesans.slice(0, 10);
        },

        pesansAll() {
            return this.$store.state.pesansAll;
        },
        pathComputed() {
            if (this.$route.path == "/app/my-pesan") {
                return true;
            }

            if (this.pesans.length == 1) {
                return true;
            }

            let cok = this.$route.path;
            let foo = cok.split("/");
            return foo[2] != null ? true : false;
        },

        jensek() {
            if (this.user && this.user.jensek) {
                let foo = false;
                switch (this.user.jensek.val) {
                    case 1:
                        foo = "tk";
                        break;
                    case 2:
                        foo = "sd";
                        break;
                    case 3:
                        foo = "smp";
                        break;
                    default:
                        foot = false;
                }
                return foo;
            }
        },

        isAdmin() {
            return this.$store.state.auth.user.role == "admin";
        },
        isOps() {
            return this.$store.state.auth.user.role == "ops";
        }
    },

    methods: {
        getAppVersion() {
            let data = this.$store.state.app_info;
            let isDataEmpty = data && data.length == 0;
            let isDataNull = !data;

            if (isDataEmpty || isDataNull) {
                axios.get("/api/app-info").then(response => {
                    let app_build = response.data.build;
                    if (app_build != this.build) {
                        window.localStorage.removeItem("hideLog");
                        this.buildDialog = true;
                    }

                    this.$store.commit("SET_APP_INFO", response.data);
                });
            }
        },

        updateAplikasi() {
            axios
                .post("/api/logout")
                .then(response => {
                    // this.$store.dispatch('sekolah/resetSekolah')
                    localStorage.removeItem("token"); //remove user token when logout
                    this.$router.push("/login");
                    setTimeout(() => {
                        location.reload();
                    }, 0); // push user to login page
                })
                .catch(errors => {});
        },

        fillConfig() {
            let data = this.$store.state.config.items;
            let isDataEmpty = data && data.length == 0;
            let isDataNull = !data;

            if (isDataEmpty || isDataNull) {
                this.$store.dispatch("config/get");
            }
        },

        fillConfigPenginputan() {
            let data = this.$store.state.config.penginputanItems;
            let isDataEmpty = data && data.length == 0;
            let isDataNull = !data;

            if (isDataEmpty || isDataNull) {
                this.$store.dispatch("config/getPenginputan");
            }
        },

        doFull(val) {
            this.drawer = val;
        },
        logout() {
            // this.$store.dispatch('sekolah/resetSekolah')
            if (!this.logoutPressed) {
                this.logoutPressed = true;
                axios
                    .post("/api/logout")
                    .then(response => {
                        // this.$store.dispatch('sekolah/resetSekolah')
                        localStorage.removeItem("token"); //remove user token when logout
                        this.$router.push("/login");
                        setTimeout(() => {
                            location.reload();
                        }, 0); // push user to login page
                    })
                    .catch(errors => {});
            }
        },

        fillSekolahnya(user_role, user_id) {
            if (user_role == "ops") {
                this.$store
                    .dispatch("sekolah/getSekolahnya", user_id)
                    .then(() => {
                        this.ready++;
                    });
            }
        },

        fillDinas(user_role) {
            if (user_role == "admin") {
                this.$store.dispatch("dinas/getDinas").then(() => {
                    this.ready++;
                });
            }
        },

        fillNotifAdmin(user_id) {
            axios.get("/api/get-notifs/" + user_id).then(res => {
                this.$store.commit("SET_PESANS", res.data);
                this.ready++;
            });
        },

        fillNotifOps(user_id) {
            this.ready++;
            axios.get("/api/get-notifs-berkala/" + user_id).then(() => {
                axios.get("/api/get-notifs/" + user_id).then(res => {
                    this.$store.commit("SET_PESANS", res.data);
                    this.ready++;
                });
            });
        },

        fillAllNotif(user_id) {
            axios.get("/api/get-all-notifs/" + user_id).then(res => {
                this.$store.commit("SET_PESANS_ALL", res.data);
                this.ready++;
            });
        },

        toPesan() {
            let path = "/app/my-pesan";
            if (this.$route.path !== path) {
                this.$router.push(path);
            }
        },

        toRoute(route, id, to) {
            axios.post("/api/mark-as-read", { id: id }).then(r => {
                if (this.isAdmin) {
                    this.fillNotifAdmin(this.$store.state.auth.user.id);
                }

                if (this.isOps) {
                    this.fillNotifOps(this.$store.state.auth.user.id);
                }
            });
            let path = `/app${route}`;
            let goToElement = to;
            if (this.$route.path !== path) {
                // this.$router.push(`${path}#${goToElement}`);
                this.$router.push(path);
                this.$store.commit("SET_ANCHOR", goToElement);
            } else {
                this.coker = false;
                this.$store.commit("SET_ANCHOR", goToElement);
            }
        },

        markRead(id) {
            axios.post("/api/mark-as-read", { id: id }).then(r => {
                if (this.isAdmin) {
                    this.fillNotifAdmin(this.$store.state.auth.user.id);
                }

                if (this.isOps) {
                    this.fillNotifOps(this.$store.state.auth.user.id);
                }
            });
        },

        markAll() {
            axios
                .put("/api/mark-all-as-read/" + this.$store.state.auth.user.id)
                .then(r => {
                    this.$store.commit("SET_PESANS", []);
                });
        }
    }
};
</script>

<style>
.myFont {
    font-family: Poppins, sans-serif;
}
.overflow-y-scroll {
    overflow-y: auto;
}
.my-main {
    background: #f9f5ff !important;
}
</style>
